// 企业用户信息
export default {
    BN: 'Business Name',
    OC: 'Organization Contact',
    CI: 'Contact Information',
    AM: 'Authorized Module',
    AV: 'Authorized Version',
    PN: 'Project Name',
    IPW: 'IP Whitelist',
    AAK: 'Add AK',
    EIPW: 'Edit IP whitelist',
    documentAddress: 'Document Address',
    tip_IP: 'IP format is not correct, please refer to the description below',
    tip_PN: 'Please enter the project name',
    tip_OSITI: 'Only servers in the IP whitelist can successfully initiate the call',
    tip_Format: 'Format: 202.198.16.3202.198.0.0/16 fill in IP address or IP prefix network segment, half width in English, comma separated. If you do not want to make any restrictions on IP, please set it to 0.0.0.0/0',
    tip_UIWC: '(use it with caution. If AK divulges its quota, it will be consumed by its users. It can be used as debug before it goes online. Please set a reasonable IP whitelist for the official online AK.)',
}